// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.small-menu {
  display: flex;
}

.select-wrapper {
  padding: 10px 20px;
  text-decoration: none;
  font-size: 14px;
  margin: 5px;
  width: -moz-fit-content;
  width: fit-content;
  color: #fff;
  background-color: var(--primary-color);
  border: 2px solid var(--primary-color);
  border-radius: 200px;
  cursor: pointer;
}
.select-wrapper:hover {
  transition: 0.5s;
  background-color: #ffffff;
  color: var(--primary-color);
  border: 2px solid var(--primary-color);
}
.select-wrapper::after {
  content: "▼";
  top: 50%;
  right: 10px;
  pointer-events: none;
}

.select-wrapper option {
  background-color: #ffffff;
  color: #000000;
  font-size: 16px;
}

.input-small-menu-container {
  position: relative;
  /* Добавляем относительное позиционирование к контейнеру */
}
.input-small-menu-container .input-container {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  min-height: 44px;
  border-radius: 4px;
  background-color: #ffffff;
  position: relative;
}
.input-small-menu-container .input-container:focus-within {
  border: 1px solid var(--secondary-color);
  box-shadow: 0 0 5px var(--secondary-color);
}
.input-small-menu-container .input-container textarea.input-mention {
  flex: 1 1;
  padding: 1px;
  border: none;
  background-color: #ffffff;
  resize: none;
  align-content: center;
  max-height: 200px;
  /* Максимальная высота */
  height: auto;
  /* Автоматическая высота в зависимости от контента */
  outline: none;
  overflow-y: auto;
  /* Добавим скролл, если контент превышает максимальную высоту */
  /* Убираем стандартное выделение у textarea */
}
.input-small-menu-container .input-container textarea.input-mention:focus-within {
  border-color: none;
  /* Цвет выделения */
  box-shadow: none;
  /* Тень вокруг контейнера */
}
.input-small-menu-container .files-preview {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}
.input-small-menu-container .files-preview .file-item {
  position: relative;
  margin: 5px;
  width: 100px;
  height: 130px;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.input-small-menu-container .files-preview .file-item .file-image {
  width: 100%;
  height: 100px;
  object-fit: cover;
}
.input-small-menu-container .files-preview .file-item .file-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
}
.input-small-menu-container .files-preview .file-item .file-icon img {
  width: 50%;
  height: 50%;
}
.input-small-menu-container .files-preview .file-item .file-name {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 5px;
  text-align: center;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.input-small-menu-container .files-preview .file-item .remove-file-btn {
  position: absolute;
  top: 0;
  right: 0;
  padding: 2px 5px;
  color: white;
  background: red;
  border: none;
  cursor: pointer;
  border-radius: 50%;
}
.input-small-menu-container .menu-list {
  position: absolute;
  bottom: 100%;
  /* Позиционирование меню над полем ввода */
  background: #ffffff;
  /* Белый фон для контраста */
  border: 1px solid #ddd;
  /* Светлая граница для разделения от фона */
  border-radius: 8px;
  /* Закругленные углы */
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  /* Максимальная высота с прокруткой */
  overflow-y: auto;
  /* Автоматическая прокрутка если содержимое превышает высоту */
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  /* Мягкая тень для отступа от фона */
  z-index: 1000;
  /* Обеспечивает, что меню находится выше других элементов */
  width: 200px;
  /* Меню занимает полную ширину контейнера */
  /* Плавное изменение высоты, чтобы избежать полос прокрутки */
  transition: max-height 0.3s ease;
  /* Стили для первого и последнего элемента */
  /* Стили для элементов списка */
}
.input-small-menu-container .menu-list::before {
  content: "";
  position: absolute;
  top: -10px;
  /* Отступ от верха меню */
  left: 10px;
  /* Отступ от левого края меню */
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #ffffff;
  /* Фон меню */
  z-index: 10;
  /* Чтобы треугольник был поверх границы */
}
.input-small-menu-container .menu-list > li:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.input-small-menu-container .menu-list > li:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.input-small-menu-container .menu-list .menu-item {
  padding: 12px 16px;
  /* Удобные отступы для клика */
  cursor: pointer;
  font-size: 16px;
  /* Читаемый размер шрифта */
  color: #333;
  /* Цвет текста */
  position: relative;
  /* Для анимации фона */
  transition: background 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;
  /* Плавные переходы */
}
.input-small-menu-container .menu-list .menu-item:hover {
  background: #f0f8ff;
  /* Легкий голубоватый фон при наведении */
  color: #0056b3;
  /* Цвет текста при наведении */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  /* Тень для выделения элемента */
}
.input-small-menu-container .menu-list .menu-item:active {
  background: #e0e0e0;
  /* Более темный фон при клике */
  color: #004085;
  /* Цвет текста при клике */
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/smallMenu.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAIhB;EACE,aAAA;AAFF;;AAKA;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EAAA,kBAAA;EACA,WAAA;EACA,sCAdc;EAed,sCAAA;EACA,oBAAA;EACA,eAAA;AAFF;AAIE;EACE,gBAAA;EACA,yBAAA;EACA,2BAtBY;EAuBZ,sCAAA;AAFJ;AAKE;EACE,YAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;AAHJ;;AAOA;EACE,yBAAA;EACA,cAAA;EACA,eAAA;AAJF;;AAOA;EACE,kBAAA;EAEA,0DAAA;AALF;AAME;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAJJ;AAMI;EACE,wCAAA;EACA,0CAAA;AAJN;AAOI;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,wBAAA;EACA,YAAA;EACA,oDAAA;EACA,aAAA;EACA,gBAAA;EACA,+DAAA;EAEA,6CAAA;AANN;AAOM;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;AALR;AAUE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AARJ;AAUI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AARN;AAUM;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AARR;AAWM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AATR;AAWQ;EACE,UAAA;EACA,WAAA;AATV;AAaM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAXR;AAcM;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAZR;AAiBE;EACE,kBAAA;EACA,YAAA;EACA,0CAAA;EACA,mBAAA;EACA,4BAAA;EACA,sBAAA;EACA,2CAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,qCAAA;EACA,gBAAA;EACA,8DAAA;EACA,0CAAA;EACA,oCAAA;EACA,aAAA;EACA,2DAAA;EACA,YAAA;EACA,2CAAA;EACA,6DAAA;EACA,gCAAA;EAmBA,4CAAA;EAWA,+BAAA;AA3CJ;AAeI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,UAAA;EACA,+BAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,aAAA;EACA,WAAA;EACA,yCAAA;AAbN;AAiBI;EACE,2BAAA;EACA,4BAAA;AAfN;AAkBI;EACE,8BAAA;EACA,+BAAA;AAhBN;AAoBI;EACE,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uEAAA;EACA,qBAAA;AAlBN;AAoBM;EACE,mBAAA;EACA,yCAAA;EACA,cAAA;EACA,8BAAA;EACA,wCAAA;EACA,gCAAA;AAlBR;AAqBM;EACE,mBAAA;EACA,+BAAA;EACA,cAAA;EACA,0BAAA;AAnBR","sourcesContent":["$secondary-color: var(--secondary-color);\n$primary-color: var(--primary-color);\n$background-color: var(--background-color);\n\n.small-menu {\n  display: flex;\n}\n\n.select-wrapper {\n  padding: 10px 20px;\n  text-decoration: none;\n  font-size: 14px;\n  margin: 5px;\n  width: fit-content;\n  color: #fff;\n  background-color: $primary-color;\n  border: 2px solid $primary-color;\n  border-radius: 200px;\n  cursor: pointer;\n\n  &:hover {\n    transition: 0.5s;\n    background-color: #ffffff;\n    color: $primary-color;\n    border: 2px solid $primary-color;\n  }\n\n  &::after {\n    content: '\\25BC';\n    top: 50%;\n    right: 10px;\n    pointer-events: none;\n  }\n}\n\n.select-wrapper option {\n  background-color: #ffffff;\n  color: #000000;\n  font-size: 16px;\n}\n\n.input-small-menu-container {\n  position: relative;\n\n  /* Добавляем относительное позиционирование к контейнеру */\n  .input-container {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ccc;\n    min-height: 44px;\n    border-radius: 4px;\n    background-color: #ffffff;\n    position: relative;\n\n    &:focus-within {\n      border: 1px solid $secondary-color;\n      box-shadow: 0 0 5px $secondary-color;\n    }\n\n    textarea.input-mention {\n      flex: 1;\n      padding: 1px;\n      border: none;\n      background-color: #ffffff;\n      resize: none;\n      align-content: center;\n      max-height: 200px;\n      /* Максимальная высота */\n      height: auto;\n      /* Автоматическая высота в зависимости от контента */\n      outline: none;\n      overflow-y: auto;\n      /* Добавим скролл, если контент превышает максимальную высоту */\n\n      /* Убираем стандартное выделение у textarea */\n      &:focus-within {\n        border-color: none;\n        /* Цвет выделения */\n        box-shadow: none;\n        /* Тень вокруг контейнера */\n      }\n    }\n  }\n\n  .files-preview {\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 10px;\n\n    .file-item {\n      position: relative;\n      margin: 5px;\n      width: 100px;\n      height: 130px;\n      border: 1px solid #ccc;\n      border-radius: 4px;\n      overflow: hidden;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n\n      .file-image {\n        width: 100%;\n        height: 100px;\n        object-fit: cover;\n      }\n\n      .file-icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 100px;\n\n        img {\n          width: 50%;\n          height: 50%;\n        }\n      }\n\n      .file-name {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        background: rgba(0, 0, 0, 0.5);\n        color: white;\n        padding: 5px;\n        text-align: center;\n        font-size: 12px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .remove-file-btn {\n        position: absolute;\n        top: 0;\n        right: 0;\n        padding: 2px 5px;\n        color: white;\n        background: red;\n        border: none;\n        cursor: pointer;\n        border-radius: 50%;\n      }\n    }\n  }\n\n  .menu-list {\n    position: absolute;\n    bottom: 100%;\n    /* Позиционирование меню над полем ввода */\n    background: #ffffff;\n    /* Белый фон для контраста */\n    border: 1px solid #ddd;\n    /* Светлая граница для разделения от фона */\n    border-radius: 8px;\n    /* Закругленные углы */\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    max-height: 200px;\n    /* Максимальная высота с прокруткой */\n    overflow-y: auto;\n    /* Автоматическая прокрутка если содержимое превышает высоту */\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n    /* Мягкая тень для отступа от фона */\n    z-index: 1000;\n    /* Обеспечивает, что меню находится выше других элементов */\n    width: 200px;\n    /* Меню занимает полную ширину контейнера */\n    /* Плавное изменение высоты, чтобы избежать полос прокрутки */\n    transition: max-height 0.3s ease;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: -10px;\n      /* Отступ от верха меню */\n      left: 10px;\n      /* Отступ от левого края меню */\n      width: 0;\n      height: 0;\n      border-left: 10px solid transparent;\n      border-right: 10px solid transparent;\n      border-bottom: 10px solid #ffffff;\n      /* Фон меню */\n      z-index: 10;\n      /* Чтобы треугольник был поверх границы */\n    }\n\n    /* Стили для первого и последнего элемента */\n    &>li:first-child {\n      border-top-left-radius: 8px;\n      border-top-right-radius: 8px;\n    }\n\n    &>li:last-child {\n      border-bottom-left-radius: 8px;\n      border-bottom-right-radius: 8px;\n    }\n\n    /* Стили для элементов списка */\n    .menu-item {\n      padding: 12px 16px;\n      /* Удобные отступы для клика */\n      cursor: pointer;\n      font-size: 16px;\n      /* Читаемый размер шрифта */\n      color: #333;\n      /* Цвет текста */\n      position: relative;\n      /* Для анимации фона */\n      transition: background 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;\n      /* Плавные переходы */\n\n      &:hover {\n        background: #f0f8ff;\n        /* Легкий голубоватый фон при наведении */\n        color: #0056b3;\n        /* Цвет текста при наведении */\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n        /* Тень для выделения элемента */\n      }\n\n      &:active {\n        background: #e0e0e0;\n        /* Более темный фон при клике */\n        color: #004085;\n        /* Цвет текста при клике */\n      }\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
